import Vue from 'vue';
import './plugins/vuetify';
import './plugins/vueForm';
import App from './App.vue';
import { createRouter } from './router';
import { ROUTES } from './router/ROUTES';
import STORE from './store/STORE';
import { createStore } from './store';
import { API } from '@/utils/api';
import './mixins/';
import CurrentUser from './orm/models/CurrentUser';

Vue.config.productionTip = false;

export function createApp() {
  const router = createRouter();
  const store = createStore();

  const { actions: currentUserActions } = STORE.modules.currentUser;

  router.beforeEach(async (to, from, next) => {
    const isPublicRoute = to.matched.some(record => record.meta.public);

    try {
      if (isPublicRoute) {
        return next();
      } else {
        const user = await CurrentUser.query().first();
        if (user) {
          next();
        } else {
          await CurrentUser.dispatch(currentUserActions.getCurrentUser);
          const user = await CurrentUser.query().first();
          await CurrentUser.dispatch(currentUserActions.setCurrentUser, user);
          next();
        }
      }
    } catch {

      await API.get('/sso/create_login_link/').then(responce => {
          window.location = responce.data.auth_link;
        })
      

      // next({
      //   name: ROUTES.login.name,
      //   query: {
      //     from: to.fullPath,
      //   },
      // });
    }

  });

  router.beforeResolve((to, from, next) => {
    const matched = router.getMatchedComponents(to);
    const prevMatched = router.getMatchedComponents(from);
    let diffed = false;

    const activated = matched.filter((c, i) => {
      return diffed || (diffed = (prevMatched[i] !== c));
    });

    if (!activated.length) {
      return next();
    }

    if (to.meta.allowedGroups) {
      const { slug } = store.state.currentGroup;
      if (!to.meta.allowedGroups.includes(slug)) {
        return next({ path: '/' });
      }
    }

    Promise.all(activated.map(c => {
      if (c.asyncData) {
        store.commit('setRouteLoadingValue', true);
        return c.asyncData({ store, route: to });
      }
    })).then(() => {
      next();
    }).catch((from) => {
      next({ name: from.name || 'dashboard' });
    }).finally(() => {
      store.commit('setRouteLoadingValue', false);
    });
  });

  const app = new Vue({
    router,
    store,
    render: h => h(App),
    metaInfo() {
      return {
        title: this.$route.meta.title,
        titleTemplate: title => `${ title } | ${ this.getParentTitle() } i-Lab R&I Database`,
      };
    },
    methods: {
      getParentTitle() {
        const parent = this.$route.meta.parent;
        const meta = parent ? ROUTES[parent].meta : undefined;
        return meta ? `${ meta.title } |` : '';
      },
    },
  });

  return { app, router };
}
